<template>
    <div class="modal" v-bind:class="modalClass">
        <div id="modal-overlay" @click="back()"></div>
        <article id="modal-edit" v-if="resource">
            <header>
                <figure><i class="icon icon-icon_layers"></i></figure>
                <div>
                    <span class="breadcrumb">
                        Attribute <i class="icon icon-icon_arrow-right"></i> Edit
                    </span>
                    <h1>{{ resource.name ? resource.name : 'Nouveau' }}</h1>
                </div>
                <div class="spacer"></div>
                <div>
                    <button @click="back()" class="bt-back"><span><i class="icon icon-icon_arrow-left"></i></span></button>
                    <button @click="submit()" class="bt-primary bt-save"><span><i class="icon icon-icon_tick"></i></span></button>
                </div>
            </header>

            <languages :localesLoaded="localesLoaded" :locales="locales" v-model="locale"></languages>

            <tabs :options="{ useUrlFragment: false }">
                <tab name="Information">

                    <form-toggle label="Allow import from products" v-model="resource.add_on_import"></form-toggle>

                    <form-toggle label="Multilangues" v-model="resource.multilingual"></form-toggle>

                    <form-select label="Parent attribute" multiple="false" v-model="resource.parent" :default="resource.parent_id" :options="attributes"></form-select>

                    <form-text :label="'slug'" v-model="resource.slug"></form-text>

                    <form-text :label="'separator'" v-model="resource.separator"></form-text>

                    <form-select label="Type" multiple="false" v-model="resource.type" :default="resource.type" :options="types"></form-select>

                    <div v-for="client in locales" v-show="client.id == locale || locale == 'all'" v-if="localesLoaded">
                        <form-text :lang="client.id" :label="'Nom'" v-model="resource.translations[client.id].name"></form-text>
                    </div>

                    <div v-for="client in locales" v-show="client.id == locale || locale == 'all'" v-if="localesLoaded">
                        <form-html label="Content" :config="config" v-model="resource.translations[client.id].description"></form-html>
                    </div>

                    <form-toggle label="Attribut de produit" v-model="resource.allowed_for_products"></form-toggle>

                    <form-checklist :label="'Models'" v-model="resource.models" :options="models"></form-checklist>

                </tab>
                <tab name="Values" v-if="resource.type && resource.type.id != 'text' && resource.type.id != 'file'">

                    <div class="table">
                        <div>
                            <div>
                                <div>Slug</div>
                                <div>Valeur</div>
                                <div>Description</div>
                                <div>Color</div>
                                <div>Picture</div>
                                <div>Default</div>
                                <div></div>
                                <div></div>
                            </div>
                        </div>
                        <draggable v-model="resource.values" @start="drag=true" @end="drag=false" :options="{handle:'.drag'}">
                            <div v-for="(value, index) in resource.values" v-show="resource.values">
                                <div><input type="text" v-model="value.slug"/></div>
                                <div>
                                    <div v-for="client in locales" v-if="localesLoaded" v-show="client.id == locale || locale == 'all'">
                                        <input type="text" v-model="value.translations[client.id].name"/>
                                        <img :src="'/src/assets/flags/'+client.id+'.svg'" class="flag">
                                    </div>
                                </div>
                                <div>
                                    <div v-for="client in locales" v-if="localesLoaded" v-show="client.id == locale || locale == 'all'">
                                        <input type="text" v-model="value.translations[client.id].description"/>
                                        <img :src="'/src/assets/flags/'+client.id+'.svg'" class="flag">
                                    </div>
                                </div>
                                <div>
                                    <input type="text" v-model="value.value"/>
                                </div>
                                <div>
                                    <form-file v-model="value.picture_id" width="60"></form-file>
                                </div>
                                <div>
                                    <div>
                                        <!--<form-toggle label="" v-model="value.is_default" :index="index" @event="updateDefaultValue"></form-toggle>-->
                                        <input type="radio" name="default" v-model="value.is_default" :value="1" @change="updateDefaultValue(index)"/>
                                    </div>
                                </div>
                                <div>
                                    <button @click="removeValue(value)" class="btn remove"><span class="icon icon-icon_close"></span></button>
                                </div>
                                <div class="drag">
                                    <i class="icon icon-drag"></i>
                                </div>
                            </div>
                        </draggable>
                    </div>

                    <div class="footer-buttons">
                        <button @click="addValue()" class="btn"><span>Ajouter</span></button>
                    </div>

                </tab>
            </tabs>
        </article>
    </div>
</template>
<script>

    import AttributeService from './AttributeService.js';
    import Edit from '../../../layouts/Edit.vue';

    export default {
        extends: Edit,
        data () {
            return {
                options: [],
                types: [
                    {id:'color', name:'Color'},
                    {id:'select', name:'Select'},
                    {id:'radio', name:'Radio'},
                    {id:'country', name:'Country'},
                    {id:'phone', name:'Phone'},
                    {id:'email', name:'Email'},
                    {id:'text', name:'Text'},
                    {id:'textarea', name:'Textarea'},
                    {id:'html', name:'Html'},
                    {id:'file', name:'file'},
                    {id:'toggle', name:'Toggle'}
                ],
                models: [
                    {id:'Maven\\WeeboxCore\\Models\\Person', name:'Person'},
                    {id:'Maven\\WeeboxCore\\Models\\Company', name:'Company'},
                    {id:'Maven\\WeeboxCore\\Models\\Scope', name:'Scope'},
                    {id:'Maven\\WeeboxShop\\Models\\Product', name:'Product'},
                    {id:'Maven\\WeeboxShop\\Models\\Category', name:'Category'},
                    {id:'Maven\\WeeboxShop\\Models\\Brand', name:'Brand'}
                ],
                attributes: []
            }
        },
        mounted: function(){

            AttributeService.all().then(response => {
                this.attributes = []
                this.isLoading = false

                for(let item of response.data){
                    if( !item.parent_id && item.id != this.resource.id ){
                        this.attributes.push(item)
                    }
                }

            })

        },
        methods:{
            updateDefaultValue: function(index){
                console.log("update", index);
                let checked = this.resource.values[index].is_default;
                for( var i=0; i<this.resource.values.length ; i++){
                    this.resource.values[i].is_default = false;
                }
                this.resource.values[index].is_default = checked;
            },
            addValue: function(){
                var data = {
                    id: null,
                    slug: "",
                    is_default: 0
                };
                this.setTranslationsTo(data, ['name','description']);
                console.log("Push", data)
                this.resource.values.push(data);
            },
            removeValue: function(value){
                console.log(value)
                let index = null
                for( var i=0; i<this.resource.values.length ; i++){
                    if( value == this.resource.values[i] ){
                        index = i
                    }
                }
                if( index != null ){ this.resource.values.splice(index,1); }
            },
            resourceLoaded: function(){
                this.setTranslations(['name','description']);
                if( this.resource.values ){
                    for( var i=0; i<this.resource.values.length ; i++){
                        this.setTranslationsTo(this.resource.values[i], ['name','description']);
                    }
                }
                this.resource.models = this.resource.modelsByScope ? this.resource.modelsByScope : []
            },
            getResource: function(){
                return {name: 'attribute', api: AttributeService}
            },
            beforeUpdate: function(){
                return true;
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/modules/config/attribute/Edit.vue